var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMcpIcon = function SvgMcpIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 13.7222C19 13.1393 18.5274 12.6667 17.9444 12.6667C17.3615 12.6667 16.8889 13.1393 16.8889 13.7222C16.8889 14.3052 17.3615 14.7778 17.9444 14.7778C18.5274 14.7778 19 14.3052 19 13.7222Z",
    fill: "#264D6D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33333 17.9444C6.33333 17.3615 5.86074 16.8889 5.27778 16.8889C4.69481 16.8889 4.22222 17.3615 4.22222 17.9444C4.22222 18.5274 4.69481 19 5.27778 19C5.86074 19 6.33333 18.5274 6.33333 17.9444Z",
    fill: "#264D6D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5556 17.9444C10.5556 17.3615 10.083 16.8889 9.5 16.8889C8.91703 16.8889 8.44444 17.3615 8.44444 17.9444C8.44444 18.5274 8.91703 19 9.5 19C10.083 19 10.5556 18.5274 10.5556 17.9444Z",
    fill: "#264D6D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33333 1.05556C6.33333 0.472588 5.86074 0 5.27778 0C4.69481 0 4.22222 0.472588 4.22222 1.05556C4.22222 1.63852 4.69481 2.11111 5.27778 2.11111C5.86074 2.11111 6.33333 1.63852 6.33333 1.05556Z",
    fill: "#264D6D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7778 17.9444C14.7778 17.3615 14.3052 16.8889 13.7222 16.8889C13.1393 16.8889 12.6667 17.3615 12.6667 17.9444C12.6667 18.5274 13.1393 19 13.7222 19C14.3052 19 14.7778 18.5274 14.7778 17.9444Z",
    fill: "#264D6D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5556 1.05556C10.5556 0.472588 10.083 0 9.5 0C8.91703 0 8.44444 0.472588 8.44444 1.05556C8.44444 1.63852 8.91703 2.11111 9.5 2.11111C10.083 2.11111 10.5556 1.63852 10.5556 1.05556Z",
    fill: "#264D6D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7778 1.05556C14.7778 0.472589 14.3052 0 13.7222 0C13.1393 0 12.6667 0.472589 12.6667 1.05556C12.6667 1.63852 13.1393 2.11111 13.7222 2.11111C14.3052 2.11111 14.7778 1.63852 14.7778 1.05556Z",
    fill: "#264D6D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19 9.5C19 8.91703 18.5274 8.44444 17.9444 8.44444C17.3615 8.44444 16.8889 8.91703 16.8889 9.5C16.8889 10.083 17.3615 10.5556 17.9444 10.5556C18.5274 10.5556 19 10.083 19 9.5Z",
    fill: "#264D6D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.11111 13.7222C2.11111 13.1393 1.63852 12.6667 1.05556 12.6667C0.472589 12.6667 0 13.1393 0 13.7222C0 14.3052 0.472589 14.7778 1.05556 14.7778C1.63852 14.7778 2.11111 14.3052 2.11111 13.7222Z",
    fill: "#264D6D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19 5.27778C19 4.69481 18.5274 4.22222 17.9444 4.22222C17.3615 4.22222 16.8889 4.69481 16.8889 5.27778C16.8889 5.86074 17.3615 6.33333 17.9444 6.33333C18.5274 6.33333 19 5.86074 19 5.27778Z",
    fill: "#264D6D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2.11111 9.5C2.11111 8.91703 1.63852 8.44444 1.05556 8.44444C0.472588 8.44444 0 8.91703 0 9.5C0 10.083 0.472588 10.5556 1.05556 10.5556C1.63852 10.5556 2.11111 10.083 2.11111 9.5Z",
    fill: "#264D6D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2.11111 5.27778C2.11111 4.69481 1.63852 4.22222 1.05556 4.22222C0.472588 4.22222 0 4.69481 0 5.27778C0 5.86074 0.472588 6.33333 1.05556 6.33333C1.63852 6.33333 2.11111 5.86074 2.11111 5.27778Z",
    fill: "#264D6D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.81627 6.33333H7.72966L5.66667 12.3333H6.64698L7.03647 11.1604H9.50602L9.88714 12.3333H10.9265L8.81627 6.33333ZM12.6667 6.33333H11.6903V12.3333H12.6667V9.33333V6.33333ZM8.26473 7.33999L9.23728 10.3333H7.30764L8.26473 7.33999Z",
    fill: "#264D6D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M4.52386 3.46429H14.476C15.0612 3.46429 15.5356 3.9387 15.5356 4.52386V14.476C15.5356 15.0612 15.0612 15.5356 14.476 15.5356H4.52386C3.93871 15.5356 3.46429 15.0612 3.46429 14.476V4.52386C3.46429 3.93871 3.9387 3.46429 4.52386 3.46429Z",
    stroke: "#264D6D",
    strokeWidth: 1.5
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMcpIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mcp_icon.eb9f1220.svg";
export { ForwardRef as ReactComponent };